import { render, staticRenderFns } from "./behaviorDetailDialog.vue?vue&type=template&id=3d39cd02&scoped=true"
import script from "./behaviorDetailDialog.vue?vue&type=script&lang=js"
export * from "./behaviorDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./behaviorDetailDialog.vue?vue&type=style&index=0&id=3d39cd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39cd02",
  null
  
)

export default component.exports